import React from "react";
import { Table } from "@sscs/ui";
import { getClassName } from "@sscs/utils";
import { Policy } from "../../types";
import Author from "../Author/Author";
import OverrideReason from "../OverrideReason/OverrideReason";
import UnsavedWarning from "../UnsavedWarning/UnsavedWarning";
import styles from "./overrideRow.module.scss";

type OverrideRowProps = {
  overrideWarning?: string;
  overrideState: Partial<Policy["override"]>;
  hasAnyOverride: boolean;
  hasUnsavedRevert: boolean;
  hasUnsavedOverride: boolean;
  className?: string;
};

const OverrideRow = ({
  overrideWarning,
  overrideState,
  hasAnyOverride,
  hasUnsavedRevert,
  hasUnsavedOverride,
  className,
}: OverrideRowProps): React.JSX.Element => {
  const fullColWidth = 5;

  if (!overrideState?.reason)
    return <Table.Row hover className={styles["override-row"]}></Table.Row>;

  return (
    <Table.Row
      hover
      className={getClassName(styles["override-row"], className, {
        [styles["has-override"]]: hasAnyOverride,
      })}
    >
      <Table.Cell colSpan={fullColWidth}>
        <div className={styles["override-row-root"]}>
          <OverrideReason
            hasUnsavedRevert={hasUnsavedRevert}
            reason={overrideState?.reason}
            overrideWarning={overrideWarning}
          />
          <Author
            isDisplayed={!hasUnsavedRevert && !hasUnsavedOverride}
            author={overrideState?.author}
            timestamp={overrideState?.timestamp}
          />
          <UnsavedWarning isDisplayed={hasUnsavedRevert} />
          <UnsavedWarning isDisplayed={hasUnsavedOverride} />
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
export default OverrideRow;
